(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kaelte-klar-cart-people"] && !Shopify.designMode) return;
  try {
    const kkRecipientRoot = () => document.querySelector('[data-kk-cart-people]');
  const kkDisplayName = (value) => String(value || '').replace(/[\u0000-\u001f\u007f-\u009f<>]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 80);
  const kkOtherLine = (line) => Boolean(line.properties && (line.properties._kk_recipient_email || line.properties._kk_purchase_for === 'other'));
  const kkRecipientStatus = (root, message) => {
    const status = root.querySelector('[data-kk-people-status]');
    status.textContent = message;
    status.hidden = !message;
  };
  const kkRecipientCheckoutReason = (root) => {
    if (root.getAttribute('aria-busy') === 'true') return root.dataset.loading;
    if (!['self', 'other'].includes(root.dataset.mode)) return root.dataset.choice;
    if (!kkDisplayName(root.querySelector('#kk-buyer-name').value)) return root.dataset.nameRequired;
    const consent = document.querySelector('[data-kk-digital-consent]');
    if (!consent?.checked || root.dataset.consentSaved !== 'true') return root.dataset.consentRequired;
    if (root.dataset.mode === 'other') {
      if (root.querySelector('#kk-recipient-email').value.trim() || root.querySelector('#kk-recipient-name').value.trim()) return root.dataset.unsaved;
      if (Number(root.dataset.otherCount) === 0) return root.dataset.empty;
    }
    return '';
  };
  const kkSyncRecipientCheckout = () => {
    const root = kkRecipientRoot();
    if (!root) return;
    const reason = kkRecipientCheckoutReason(root);
    const checkout = document.querySelector('[data-kk-recipient-checkout]');
    if (checkout) checkout.disabled = Boolean(reason);
    const hint = document.querySelector('[data-kk-checkout-hint]');
    if (hint) {
      if (hint.textContent !== reason) hint.textContent = reason;
      hint.hidden = !reason;
    }
    const nameUnsaved = kkDisplayName(root.querySelector('#kk-buyer-name').value) !== root.dataset.savedName;
    document.querySelectorAll('.kk-cart-shell .additional-checkout-buttons').forEach((element) => { element.inert = Boolean(reason) || nameUnsaved; });
  };
  const kkRecipientBusy = (root, busy) => {
    root.setAttribute('aria-busy', String(busy));
    root.querySelectorAll('input, select, button').forEach((element) => { element.disabled = busy || element.dataset?.kkUnavailable === 'true'; });
    const consent = document.querySelector('[data-kk-digital-consent]');
    if (consent) consent.disabled = busy;
    kkSyncRecipientCheckout();
  };
  const kkRecipientFetch = async (url, body) => {
    const response = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('cart-request');
    return response.json();
  };
  const kkRecipientReload = () => { window.location.hash = 'kk-cart-people'; window.location.reload(); };
  const kkSaveBuyerName = async (root) => {
    const input = root.querySelector('#kk-buyer-name');
    const name = kkDisplayName(input.value);
    if (name === root.dataset.savedName) return;
    const cart = await kkRecipientFetch(root.dataset.updateUrl + '.js', { attributes: { kk_display_name: name } });
    if ((cart.attributes?.kk_display_name || '') !== name) throw new Error('name-not-saved');
    input.value = name;
    root.dataset.savedName = name;
  };
  const kkSavePurchaseChoice = async (root, mode, updates) => {
    const attributes = { kk_purchase_choice: mode, kk_purchase_choice_key: root.dataset.ownAccessKey || '' };
    const cart = await kkRecipientFetch(root.dataset.updateUrl + '.js', { attributes, ...(updates ? { updates } : {}) });
    if (cart.attributes?.kk_purchase_choice !== mode || cart.attributes?.kk_purchase_choice_key !== attributes.kk_purchase_choice_key) throw new Error('choice-not-saved');
    root.dataset.mode = mode;
  };
  const kkSaveDigitalConsent = async (root, accepted) => {
    const value = accepted ? root.dataset.consentVersion : '';
    const cart = await kkRecipientFetch(root.dataset.updateUrl + '.js', { attributes: { kk_digital_consent: value } });
    if ((cart.attributes?.kk_digital_consent || '') !== value) throw new Error('consent-not-saved');
    root.dataset.consentSaved = String(accepted);
  };
  document.addEventListener('change', async (event) => {
    if (!event.target.matches?.('[data-kk-digital-consent]')) return;
    const root = kkRecipientRoot();
    if (!root || root.getAttribute('aria-busy') === 'true') return;
    const input = event.target;
    const accepted = input.checked;
    kkRecipientBusy(root, true);
    kkRecipientStatus(root, '');
    try { await kkSaveDigitalConsent(root, accepted); }
    catch {
      input.checked = !accepted;
      kkRecipientStatus(root, root.dataset.error);
    } finally { kkRecipientBusy(root, false); }
  });
  document.addEventListener('change', async (event) => {
    if (event.target.id !== 'kk-buyer-name') return;
    const root = kkRecipientRoot();
    if (!root || root.getAttribute('aria-busy') === 'true') return;
    kkRecipientBusy(root, true);
    kkRecipientStatus(root, '');
    try { await kkSaveBuyerName(root); }
    catch { kkRecipientStatus(root, root.dataset.error); }
    finally { kkRecipientBusy(root, false); }
  });
  document.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-kk-cart-people] input[name="kk-purchase-for"]');
    if (!input || !input.checked) return;
    const root = input.closest('[data-kk-cart-people]');
    if (root.getAttribute('aria-busy') === 'true') return;
    kkRecipientStatus(root, '');
    const previousMode = root.dataset.mode;
    if (input.value === 'self' && Number(root.dataset.otherCount) > 0 && !window.confirm(root.dataset.confirm)) {
      const selfRadio = root.querySelector('input[value="self"]');
      if (selfRadio) selfRadio.checked = previousMode === 'self';
      root.querySelector('input[value="other"]').checked = previousMode === 'other';
      return;
    }
    kkRecipientBusy(root, true);
    try {
      const updates = {};
      if (input.value === 'self' && Number(root.dataset.otherCount) > 0) {
        await kkSaveBuyerName(root);
        const cart = await kkRecipientFetch(root.dataset.cartUrl + '.js');
        cart.items.filter(kkOtherLine).forEach((line) => { updates[line.key] = 0; });
      }
      await kkSavePurchaseChoice(root, input.value, Object.keys(updates).length ? updates : undefined);
      if (Object.keys(updates).length) { kkRecipientReload(); return; }
      kkRecipientBusy(root, false);
      if (input.value === 'other') root.querySelector('#kk-recipient-name').focus({ preventScroll: true });
    } catch {
      kkRecipientBusy(root, false);
      root.dataset.mode = previousMode;
      const selfRadio = root.querySelector('input[value="self"]');
      if (selfRadio) selfRadio.checked = previousMode === 'self';
      root.querySelector('input[value="other"]').checked = previousMode === 'other';
      kkSyncRecipientCheckout();
      kkRecipientStatus(root, root.dataset.error);
    }
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-kk-discard-recipient]')) return;
    const root = kkRecipientRoot();
    if (!root || root.getAttribute('aria-busy') === 'true') return;
    ['#kk-recipient-name', '#kk-recipient-email'].forEach((selector) => {
      const input = root.querySelector(selector);
      input.value = '';
      input.setCustomValidity('');
    });
    kkRecipientStatus(root, '');
    kkSyncRecipientCheckout();
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches('#kk-recipient-email, #kk-recipient-name, #kk-buyer-name')) {
      event.target.setCustomValidity('');
      kkRecipientStatus(kkRecipientRoot(), '');
      kkSyncRecipientCheckout();
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-kk-recipient-form]');
    if (!form) return;
    event.preventDefault();
    const root = form.closest('[data-kk-cart-people]');
    if (root.getAttribute('aria-busy') === 'true' || !form.reportValidity()) return;
    const input = form.querySelector('#kk-recipient-email');
    const email = input.value.trim().toLowerCase();
    const nameInput = form.querySelector('#kk-recipient-name');
    const name = kkDisplayName(nameInput.value);
    if (!name) { nameInput.setCustomValidity(root.dataset.nameRequired); nameInput.reportValidity(); return; }
    const select = form.querySelector('#kk-recipient-plan');
    const option = select.selectedOptions[0];
    if (!email || !option) return;
    kkRecipientBusy(root, true);
    kkRecipientStatus(root, root.dataset.loading);
    try {
      await kkSaveBuyerName(root);
      const cart = await kkRecipientFetch(root.dataset.cartUrl + '.js');
      if (cart.items.some((line) => String(line.properties?._kk_recipient_email || '').trim().toLowerCase() === email)) {
        kkRecipientBusy(root, false);
        kkRecipientStatus(root, root.dataset.duplicate);
        input.setCustomValidity(root.dataset.duplicate);
        input.reportValidity();
        return;
      }
      const recipientProperties = {
        _kk_purchase_for: 'other', _kk_recipient_email: email, _kk_recipient_name: name, 'Zugang für': email,
        _kk_access_tier: option.dataset.tier, _kk_circuit_access: 'false',
        'Prüfungsbereich': option.dataset.scope
      };
      const items = [{ id: Number(option.value), quantity: 1, properties: recipientProperties }];
      form.querySelectorAll('[data-kk-recipient-addon]:checked').forEach((addon) => {
        const moduleName = addon.dataset.kkRecipientAddon;
        const id = Number(addon.value);
        if (!Number.isSafeInteger(id) || id <= 0) return;
        items.push({ id, quantity: 1, properties: {
          _kk_purchase_for: 'other', _kk_recipient_email: email, _kk_recipient_name: name, 'Zugang für': email,
          _kk_module: moduleName,
          'Zusatzmodul': moduleName === 'circuit' ? 'Kältekreislauf' : 'Störungssimulation'
        } });
      });
      await kkRecipientFetch(root.dataset.addUrl + '.js', { items: [...items].reverse() });
      kkRecipientReload();
    } catch {
      kkRecipientBusy(root, false);
      kkRecipientStatus(root, root.dataset.error);
    }
  }, true);
  const kkGuardRecipientCheckout = (event) => {
    const root = kkRecipientRoot();
    if (!root) return;
    const isCheckoutClick = event.type === 'click' && event.target.closest('[name="checkout"], .additional-checkout-buttons');
    const isCheckoutSubmit = event.type === 'submit' && event.target.getAttribute('id') === 'cart-form';
    if (!isCheckoutClick && !isCheckoutSubmit) return;
    const busy = root.getAttribute('aria-busy') === 'true';
    const reason = kkRecipientCheckoutReason(root) || (event.type === 'click' && event.target.closest('.additional-checkout-buttons') && kkDisplayName(root.querySelector('#kk-buyer-name').value) !== root.dataset.savedName ? root.dataset.loading : '');
    if (!reason) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    kkSyncRecipientCheckout();
    kkRecipientStatus(root, reason);
    root.scrollIntoView({ behavior: 'auto', block: 'start' });
    if (!busy) {
      const target = reason === root.dataset.nameRequired ? root.querySelector('#kk-buyer-name')
        : reason === root.dataset.consentRequired ? document.querySelector('[data-kk-digital-consent]')
        : root.dataset.mode === 'other' ? root.querySelector('#kk-recipient-email')
        : root.querySelector('input[value="self"]') || root.querySelector('input[value="other"]');
      target?.focus({ preventScroll: true });
    }
  };
  document.addEventListener('click', kkGuardRecipientCheckout, true);
  document.addEventListener('submit', kkGuardRecipientCheckout, true);
  const kkInitRecipientCheckout = () => {
    kkSyncRecipientCheckout();
    const shell = document.querySelector('.kk-cart-shell');
    if (shell) new MutationObserver(kkSyncRecipientCheckout).observe(shell, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kkInitRecipientCheckout, { once: true });
  else kkInitRecipientCheckout();
  window.addEventListener('pageshow', kkSyncRecipientCheckout);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kaelte-klar-cart-plan"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-kk-plan-duration], [data-kk-plan-scope], [data-kk-recipient-addon]');
    if (!input || (input.type === 'radio' && !input.checked)) return;
    const picker = input.closest('[data-kk-plan-picker]');
    if (!picker || picker.closest('[aria-busy="true"]')) return;
    const select = picker.querySelector('#kk-recipient-plan');
    const options = Array.from(select.options);
    const duration = picker.querySelector('[data-kk-plan-duration]:checked')?.value;
    const scope = picker.querySelector('[data-kk-plan-scope]:checked')?.value;
    const selected = options.find((option) => option.dataset.duration === duration && option.dataset.scope === scope)
      || options.find((option) => option.dataset.duration === duration);
    if (!selected) return;
    select.value = selected.value;
    picker.querySelectorAll('[data-kk-plan-scope]').forEach((radio) => {
      const option = options.find((candidate) => candidate.dataset.duration === duration && candidate.dataset.scope === radio.value);
      radio.checked = radio.value === selected.dataset.scope;
      radio.disabled = !option;
      radio.dataset.kkUnavailable = String(!option);
      radio.closest('label').querySelector('[data-kk-scope-price]').textContent = option ? option.dataset.price : picker.dataset.unavailable;
    });
    const addons = Array.from(picker.querySelectorAll('[data-kk-recipient-addon]:checked')).filter((addon) => !addon.disabled && addon.dataset.priceAmount != null);
    const amount = Number(selected.dataset.priceAmount) + addons.reduce((sum, addon) => sum + Number(addon.dataset.priceAmount), 0);
    picker.querySelector('[data-kk-plan-name]').textContent = selected.dataset.duration + ' · ' + selected.dataset.scope + addons.map((addon) => ' + ' + addon.dataset.addonName).join('');
    picker.querySelector('[data-kk-plan-price]').textContent = Number.isSafeInteger(amount) ? new Intl.NumberFormat(document.documentElement?.lang || 'de-DE', { style: 'currency', currency: picker.dataset.currency || 'EUR' }).format(amount / 100) : selected.dataset.price;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kaelte-klar-header"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.kkCompactHeaderReady) return;
    window.kkCompactHeaderReady = true;
    var pending = false;
    var scrollContainer = document.querySelector('.page-wrapper') || document.scrollingElement;
    var headers = Array.prototype.slice.call(document.querySelectorAll('.kk-nav[data-kk-fixed-header]'));
    var phoneQuery = window.matchMedia('(max-width:760px)');
    var landscapeTabletQuery = window.matchMedia('(min-width:980px) and (orientation:landscape) and (any-pointer:coarse)');
    var portraitTabletQuery = window.matchMedia('(min-width:761px) and (orientation:portrait) and (any-pointer:coarse)');
    var phoneHeader = null;
    var headerPlaceholder = null;
    var phoneViewportWidth = 0;
    function syncPhoneGeometry() {
      if (!phoneHeader) return;
      var viewportWidth = document.documentElement.clientWidth;
      if (viewportWidth === phoneViewportWidth) return;
      phoneViewportWidth = viewportWidth;
      var fullWidth = Math.max(1, viewportWidth - 24);
      var compactWidth = Math.min(320, Math.max(1, viewportWidth - 32));
      phoneHeader.style.setProperty('--kk-phone-scale', (compactWidth / fullWidth).toFixed(6));
      phoneHeader.style.setProperty('--kk-phone-shift', Math.max(0, (fullWidth - compactWidth) / 2 - 2) + 'px');
    }
    function syncHeaderLayer() {
      if (phoneQuery.matches) {
        if (!phoneHeader) {
          var visibleHeader = headers.find(function(header) { return header.getClientRects().length > 0; });
          if (!visibleHeader) return;
          phoneHeader = visibleHeader;
          headerPlaceholder = document.createComment('');
          phoneHeader.before(headerPlaceholder);
          document.body.prepend(phoneHeader);
        }
        syncPhoneGeometry();
      } else if (phoneHeader) {
        headerPlaceholder.replaceWith(phoneHeader);
        phoneHeader = null;
        headerPlaceholder = null;
        phoneViewportWidth = 0;
      }
    }
    function syncWideGeometry() {
      if (phoneQuery.matches) return;
      var portraitTablet = portraitTabletQuery.matches;
      var smallTablet = !portraitTablet && window.matchMedia('(max-width:800px)').matches;
      var geometry = headers.map(function(header) {
        return { header:header, width:header.offsetWidth, height:header.offsetHeight };
      });
      geometry.forEach(function(item) {
        if (!item.width || !item.height) return;
        var width = Math.min(smallTablet ? 360 : 440, item.width - 16);
        var height = smallTablet ? 50 : 56;
        item.header.style.setProperty('--kk-nav-inset', Math.max(0, (item.width - width) / 2) + 'px');
        item.header.style.setProperty('--kk-nav-ratio', (width / item.width).toFixed(6));
        item.header.style.setProperty('--kk-nav-height-ratio', (height / item.height).toFixed(6));
        item.header.style.setProperty('--kk-nav-rise', ((height - item.height) / 2) + 'px');
      });
    }
    function updateHeaders() {
      var containerOffset = scrollContainer ? scrollContainer.scrollTop : 0;
      var windowOffset = window.scrollY || document.documentElement.scrollTop || 0;
      var offset = Math.max(0, containerOffset, windowOffset);
      headers.forEach(function(header) {
        var isCompact = header.classList.contains('kk-nav--compact');
        var shouldCompact = offset > (isCompact ? 24 : 72);
        if (shouldCompact !== isCompact) header.classList.toggle('kk-nav--compact', shouldCompact);
      });
      pending = false;
    }
    function requestUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(updateHeaders);
    }
    function syncTabletNavigation() {
      if (landscapeTabletQuery.matches || portraitTabletQuery.matches) {
        document.querySelectorAll('.kk-mobile-nav[open]').forEach(function(menu) { menu.open = false; });
      }
      closeTabletNavigation();
    }
    function closeTabletNavigation() {
      headers.forEach(function(header) {
        if (!header.classList.contains('kk-nav--peek')) return;
        header.classList.toggle('kk-nav--peek', false);
        header.querySelector('.kk-nav__expand').setAttribute('aria-expanded', 'false');
      });
    }
    function handleScroll() {
      closeTabletNavigation();
      requestUpdate();
    }
    syncHeaderLayer();
    syncWideGeometry();
    syncTabletNavigation();
    updateHeaders();
    if (typeof ResizeObserver !== 'undefined') {
      var geometryObserver = new ResizeObserver(syncWideGeometry);
      headers.forEach(function(header) { geometryObserver.observe(header); });
    }
    if (scrollContainer) scrollContainer.addEventListener('scroll', handleScroll, { passive:true });
    window.addEventListener('scroll', handleScroll, { passive:true });
    window.addEventListener('resize', function() { syncPhoneGeometry(); syncWideGeometry(); }, { passive:true });
    window.addEventListener('pageshow', function() { syncHeaderLayer(); syncWideGeometry(); syncTabletNavigation(); requestUpdate(); });
    phoneQuery.addEventListener('change', function() { syncHeaderLayer(); syncWideGeometry(); requestUpdate(); });
    landscapeTabletQuery.addEventListener('change', function() { syncWideGeometry(); syncTabletNavigation(); requestUpdate(); });
    portraitTabletQuery.addEventListener('change', function() { syncWideGeometry(); syncTabletNavigation(); requestUpdate(); });
    document.addEventListener('click', function(event) {
      if (!(event.target instanceof Element)) return;
      var expandButton = event.target.closest('.kk-nav__expand');
      if (expandButton && (landscapeTabletQuery.matches || portraitTabletQuery.matches)) {
        var expandedHeader = expandButton.closest('.kk-nav');
        expandedHeader.classList.toggle('kk-nav--peek', true);
        expandButton.setAttribute('aria-expanded', 'true');
        if (event.detail === 0) expandedHeader.querySelector('.kk-nav__links a').focus({ preventScroll:true });
        return;
      }
      if (!event.target.closest('.kk-nav') || event.target.closest('.kk-nav__links a')) closeTabletNavigation();
      document.querySelectorAll('.kk-mobile-nav[open]').forEach(function(menu) {
        if (!menu.contains(event.target) || event.target.closest('.kk-mobile-nav__panel a,.kk-mobile-nav__panel button')) menu.open = false;
      });
    });
    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') return;
      headers.forEach(function(header) {
        if (!header.classList.contains('kk-nav--peek')) return;
        var expandButton = header.querySelector('.kk-nav__expand');
        closeTabletNavigation();
        expandButton.focus({ preventScroll:true });
      });
      document.querySelectorAll('.kk-mobile-nav[open]').forEach(function(menu) {
        menu.open = false;
        menu.querySelector('summary').focus();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kaelte-klar-learning-path"] && !Shopify.designMode) return;
  try {
    (()=>{
    function init(root){
      if(root.dataset.pathReady)return;root.dataset.pathReady='true';
      const tabs=[...root.querySelectorAll('[role="tab"]')];
      function select(tab,focus){tabs.forEach(button=>{const active=button===tab;button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;const panel=document.getElementById(button.getAttribute('aria-controls'));if(panel)panel.hidden=!active});if(focus)tab.focus({preventScroll:true})}
      tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab,false));tab.addEventListener('keydown',event=>{let target;if(event.key==='ArrowRight')target=(index+1)%tabs.length;if(event.key==='ArrowLeft')target=(index+tabs.length-1)%tabs.length;if(event.key==='Home')target=0;if(event.key==='End')target=tabs.length-1;if(target!==undefined){event.preventDefault();select(tabs[target],true)}})});
    }
    const scan=()=>document.querySelectorAll('[data-kk-learning-path]').forEach(init);scan();document.addEventListener('shopify:section:load',scan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kaelte-klar-public-info"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.kkPublicInfoReady) return;
    window.kkPublicInfoReady = true;
    var previousFocus = new WeakMap();
    function panelFor(key) {
      return Array.from(document.querySelectorAll('[data-kk-info-key]')).find(function(panel) { return panel.dataset.kkInfoKey === key; });
    }
    function openPanel(panel) {
      if (!panel || panel.open) return;
      document.querySelectorAll('.kk-public-info[open]').forEach(function(other) { other.close(); });
      previousFocus.set(panel, document.activeElement);
      panel.showModal();
      panel.scrollTop = 0;
      panel.focus({ preventScroll:true });
    }
    function fromHash() {
      var prefix = '#kk-info-';
      if (location.hash.indexOf(prefix) === 0) openPanel(panelFor(location.hash.slice(prefix.length)));
    }
    document.addEventListener('click', function(event) {
      var close = event.target.closest('[data-kk-info-close]');
      if (close) { close.closest('dialog').close(); return; }
      if (event.target.matches('dialog.kk-public-info')) { event.target.close(); return; }
      var link = event.target.closest('a[href]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.hasAttribute('data-kk-withdrawal-open')) {
        document.querySelectorAll('.kk-public-info[open]').forEach(function(panel) { panel.close(); });
        return;
      }
      var url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      var key = url.hash.indexOf('#kk-info-') === 0 ? url.hash.slice(9) : '';
      var policyMatch = url.pathname.match(/\/policies\/([^/]+)\/?$/);
      if (policyMatch) key = policyMatch[1] === 'contact-information' ? 'contact' : policyMatch[1];
      var root = document.querySelector('[data-kk-public-info]');
      if (root && root.dataset.passwordPage === 'true' && /\/pages\/contact\/?$/.test(url.pathname)) key = 'contact';
      var panel = panelFor(key);
      if (!panel) return;
      event.preventDefault();
      var menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
      openPanel(panel);
    });
    document.addEventListener('close', function(event) {
      var panel = event.target;
      if (!panel.matches('.kk-public-info')) return;
      if (location.hash === '#kk-info-' + panel.dataset.kkInfoKey) history.replaceState(null, '', location.pathname + location.search);
      var previous = previousFocus.get(panel);
      if (previous && previous.isConnected) previous.focus({ preventScroll:true });
    }, true);
    window.addEventListener('hashchange', fromHash);
    fromHash();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kaelte-klar-withdrawal"] && !Shopify.designMode) return;
  try {
    (function() {
    function setup(root) {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      var dialog = root.querySelector('[data-kk-withdrawal-dialog]');
      var dialogHeader = root.querySelector('.kk-withdrawal__header');
      var form = root.querySelector('[data-kk-withdrawal-form]');
      var formStep = root.querySelector('[data-kk-withdrawal-form-step]');
      var confirmStep = root.querySelector('[data-kk-withdrawal-confirm-step]');
      var successStep = root.querySelector('[data-kk-withdrawal-success-step]');
      var submitButton = root.querySelector('[data-kk-withdrawal-submit]');
      var formError = root.querySelector('[data-kk-withdrawal-error]');
      var submitError = root.querySelector('[data-kk-withdrawal-submit-error]');
      var requestKey = '';
      var dialogScrollPending = false;

      function updateDialogViewport() {
        root.style.setProperty('--kkw-viewport', document.documentElement.clientWidth + 'px');
      }

      function updateDialogHeader() {
        var isCompact = dialogHeader.classList.contains('kk-withdrawal__header--compact');
        var shouldCompact = Math.max(0, dialog.scrollTop) > 72;
        if (shouldCompact !== isCompact) dialogHeader.classList.toggle('kk-withdrawal__header--compact', shouldCompact);
        dialogScrollPending = false;
      }

      function requestDialogHeaderUpdate() {
        if (dialogScrollPending) return;
        dialogScrollPending = true;
        window.requestAnimationFrame(updateDialogHeader);
      }

      function show(step) {
        [formStep, confirmStep, successStep].forEach(function(item) { item.hidden = item !== step; });
        root.dataset.step = step === formStep ? 'form' : step === confirmStep ? 'confirm' : 'success';
        root.querySelector('.kk-withdrawal__dialog').scrollTo({ top: step === formStep ? 0 : root.querySelector('.kk-withdrawal__workspace').offsetTop - 18, behavior: 'smooth' });
      }

      function reset() {
        form.reset();
        requestKey = '';
        formError.hidden = true;
        submitError.hidden = true;
        show(formStep);
      }

      function openWithdrawal(openButton) {
          root.dataset.step = 'form';
          updateDialogViewport();
          if (!dialog.open) dialog.showModal();
          dialog.focus({ preventScroll:true });
          var mobileMenu = openButton && openButton.closest('details');
          if (mobileMenu) mobileMenu.removeAttribute('open');
      }
      document.addEventListener('click', function(event) {
        var openButton = event.target.closest('[data-kk-withdrawal-open]');
        if (!openButton) return;
        event.preventDefault();
        openWithdrawal(openButton);
      });
      function openFromHash() { if (location.hash === '#kk-withdrawal') openWithdrawal(); }
      window.addEventListener('hashchange', openFromHash);
      openFromHash();
      root.querySelector('[data-kk-withdrawal-close]').addEventListener('click', function() { dialog.close(); });
      root.querySelector('[data-kk-withdrawal-done]').addEventListener('click', function() { dialog.close(); });
      root.querySelector('[data-kk-withdrawal-back]').addEventListener('click', function() { show(formStep); });
      dialog.addEventListener('click', function(event) { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('scroll', requestDialogHeaderUpdate, { passive:true });
      window.addEventListener('resize', updateDialogViewport, { passive:true });
      dialog.addEventListener('close', function() {
        reset();
        if (location.hash === '#kk-withdrawal') history.replaceState(null, '', location.pathname + location.search);
      });

      form.addEventListener('submit', function(event) {
        event.preventDefault();
        formError.hidden = true;
        var invalid = form.querySelector(':invalid');
        if (invalid) {
          invalid.setAttribute('aria-invalid', 'true');
          invalid.reportValidity();
          return;
        }
        form.querySelectorAll('[aria-invalid="true"]').forEach(function(input) { input.removeAttribute('aria-invalid'); });
        var data = new FormData(form);
        root.querySelector('[data-kk-summary-name]').textContent = data.get('name');
        root.querySelector('[data-kk-summary-email]').textContent = data.get('email');
        root.querySelector('[data-kk-summary-order]').textContent = data.get('orderReference');
        show(confirmStep);
      });

      submitButton.addEventListener('click', function() {
        submitError.hidden = true;
        var originalLabel = submitButton.textContent;
        submitButton.disabled = true;
        submitButton.textContent = submitButton.dataset.loadingLabel;
        if (!requestKey) requestKey = crypto.randomUUID();
        var data = new FormData(form);
        fetch(root.dataset.apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: data.get('name'),
            email: data.get('email'),
            orderReference: data.get('orderReference'),
            message: data.get('message'),
            website: data.get('website'),
            requestKey: requestKey
          })
        }).then(function(response) {
          return response.json().then(function(payload) {
            if (!response.ok) throw new Error(payload.error || 'Der Widerruf konnte gerade nicht übermittelt werden.');
            return payload;
          });
        }).then(function(payload) {
          root.querySelector('[data-kk-withdrawal-reference]').textContent = payload.reference;
          root.querySelector('[data-kk-withdrawal-time]').textContent = new Intl.DateTimeFormat('de-DE', { dateStyle:'long', timeStyle:'short' }).format(new Date(payload.receivedAt)) + ' Uhr';
          show(successStep);
        }).catch(function(error) {
          submitError.textContent = error.message;
          submitError.hidden = false;
        }).finally(function() {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        });
      });
    }
    document.querySelectorAll('[data-kk-withdrawal]').forEach(setup);
  })();
  } catch(e) { console.error(e); }
})();

})();
